import React, { useState } from 'react';

const PirotecniaPage: React.FC = () => {
  const [showCastillosModal, setShowCastillosModal] = useState(false);

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 via-slate-800 to-slate-700">
      {/* Navigation */}
      <nav className="bg-black/80 backdrop-blur-md border-b-2 border-gradient-to-r from-yellow-400 via-orange-500 to-yellow-400">
        <div className="max-w-7xl mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            {/* Logo */}
            <div className="flex items-center space-x-3 ml-0">
              <div className="bg-black/20 backdrop-blur-sm rounded-xl p-1 border border-yellow-400/30">
                <img 
                  src="https://static.readdy.ai/image/f83f5cd629da4d80734129e80e4e4145/4a7f8b54088d811b1f1eaf12115718e6.jpeg" 
                  alt="ESPECTÁCULOS BRONCHÚ Logo" 
                  className="h-14 w-14 rounded-lg shadow-lg object-cover"
                />
              </div>
              <div>
                <h1 className="text-xl font-black text-white font-sans tracking-widest drop-shadow-2xl" style={{fontFamily: 'Inter, system-ui, sans-serif', letterSpacing: '0.2em', textShadow: '2px 2px 4px rgba(0,0,0,0.8)'}}>
                  ESPECTÁCULOS BRONCHÚ
                </h1>
                <p className="text-xs text-yellow-400 font-light tracking-widest" style={{letterSpacing: '0.25em'}}>
                  L'ART DEL FOC I EL SO
                </p>
              </div>
            </div>

            {/* Navigation Menu */}
            <div className="hidden md:flex items-center space-x-8">
              <a href="/" className="text-white hover:text-yellow-400 transition-colors duration-300 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
                INICIO
              </a>
              <a href="/pirotecnia" className="text-yellow-400 border-b-2 border-yellow-400 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
                FUEGOS ARTIFICIALES
              </a>
              <a href="/eventos" className="text-white hover:text-yellow-400 transition-colors duration-300 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
                EVENTOS
              </a>
              <a href="/videos" className="text-white hover:text-yellow-400 transition-colors duration-300 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
                VIDEOS
              </a>
              <a href="/calendario" className="text-white hover:text-yellow-400 transition-colors duration-300 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
                CALENDARIO
              </a>
              <a href="/merchandising" className="text-white hover:text-yellow-400 transition-colors duration-300 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
                MERCHANDISING
              </a>
              <a href="/nosotros" className="text-white hover:text-yellow-400 transition-colors duration-300 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
                NOSOTROS
              </a>
              <a href="/contacto" className="text-white hover:text-yellow-400 transition-colors duration-300 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
                CONTACTO
              </a>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative py-32">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://readdy.ai/api/search-image?query=spectacular%20mascleta%20fireworks%20explosion%20in%20full%20action%2C%20Valencia%20Spain%2C%20massive%20colorful%20sparks%20and%20smoke%20clouds%2C%20dramatic%20evening%20sky%2C%20professional%20pyrotechnics%20display%2C%20intense%20orange%20red%20golden%20fire%20effects&width=1920&height=800&seq=20&orientation=landscape')`
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-b from-gray-900/50 via-gray-900/30 to-gray-900/50"></div>
        </div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-6 text-center">
          <h1 className="text-7xl font-bold text-white mb-6 tracking-wider drop-shadow-2xl">
            FUEGOS<br />
            <span className="bg-gradient-to-r from-orange-400 via-yellow-400 to-red-500 bg-clip-text text-transparent">
              ARTIFICIALES
            </span>
          </h1>
          
          <p className="text-2xl text-yellow-400 mb-12 font-serif tracking-wider">
            17 años perfeccionando el arte de la pirotécnica profesional
          </p>
          
          <button className="bg-gradient-to-r from-yellow-400 to-orange-500 text-black px-8 py-4 rounded-lg font-bold text-lg tracking-wider hover:scale-105 transition-transform duration-300 flex items-center space-x-2 mx-auto cursor-pointer whitespace-nowrap">
            <i className="ri-fire-line text-xl"></i>
            <span>SOLICITAR PRESUPUESTO</span>
          </button>
        </div>
      </section>

      {/* Producto Estrella - Mascletas en Miniatura */}
      <section className="py-20 bg-gradient-to-b from-slate-800 to-slate-700 relative overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute top-10 left-10 w-3 h-3 bg-yellow-400 rounded-full animate-pulse opacity-30"></div>
          <div className="absolute top-32 right-20 w-2 h-2 bg-red-400 rounded-full animate-bounce opacity-40" style={{animationDelay: '1s'}}></div>
          <div className="absolute bottom-20 left-1/3 w-2.5 h-2.5 bg-orange-400 rounded-full animate-pulse opacity-20" style={{animationDelay: '2s'}}></div>
        </div>
        
        <div className="max-w-7xl mx-auto px-6 relative">
          <div className="text-center mb-16">
            <div className="bg-gradient-to-r from-yellow-400 to-orange-500 text-black px-6 py-3 rounded-full text-sm font-bold mb-6 inline-block tracking-wider shadow-lg">
              <i className="ri-star-fill mr-2"></i>
              NUESTRO PRODUCTO ESTRELLA
            </div>
            <h2 className="text-6xl font-serif font-bold text-white tracking-wider mb-8">
              MASCLETAS EN
              <span className="block bg-gradient-to-r from-orange-400 via-yellow-400 to-red-500 bg-clip-text text-transparent">
                MINIATURA
              </span>
            </h2>
            <p className="text-2xl text-gray-300 max-w-4xl mx-auto leading-relaxed font-light">
              EL ESPECTÁCULO MÁS REPRESENTATIVO DE ESPECTÁCULOS BRONCHÚ
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-20">
            {/* Imagen Principal */}
            <div className="relative">
              <div 
                className="h-96 bg-cover bg-center rounded-3xl shadow-2xl border-4 border-yellow-400/50"
                style={{
                  backgroundImage: `url('https://static.readdy.ai/image/f83f5cd629da4d80734129e80e4e4145/b8606b5caf57465c8f35255a0a247377.webp')`
                }}
              >
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent rounded-3xl"></div>
                <div className="absolute bottom-6 left-6 right-6">
                  <div className="bg-black/70 backdrop-blur-sm rounded-lg p-4">
                    <p className="text-yellow-400 font-bold text-lg">
                      INNOVACIÓN ÚNICA EN PIROTÉCNICA
                    </p>
                    <p className="text-white text-sm">
                      Adaptable a cualquier espacio y localización
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Contenido Descriptivo */}
            <div>
              <h3 className="text-4xl font-bold text-white mb-8 tracking-wider">
                LA SOLUCIÓN PERFECTA PARA CUALQUIER ESPACIO
              </h3>
              
              <div className="space-y-6 text-gray-300 leading-relaxed">
                <p className="text-lg">
                  Las <strong className="text-yellow-400">mascletas en miniatura</strong> son nuestro producto más representativo, 
                  diseñadas específicamente para adaptarse a todo tipo de espacios y localizaciones.
                </p>
                
                <p className="text-lg">
                  Ofrecen la posibilidad de disfrutar de un espectáculo de fuegos artificiales tan característico 
                  como una mascleta tradicional en lugares donde de otra forma no sería posible, ya sea por 
                  <strong className="text-orange-400"> limitaciones de espacio o por no cumplir los requisitos legales 
                  de seguridad</strong> que exigen los calibres mayores.
                </p>

                <p className="text-lg">
                  Al usar <strong className="text-yellow-400">calibres menores</strong>, requieren 
                  <strong className="text-orange-400"> menor distancia de seguridad tanto a edificios como al público</strong>, 
                  lo que las convierte en la solución perfecta para espacios urbanos y localizaciones con restricciones.
                </p>

                <div className="bg-slate-600/50 rounded-xl p-6 border-l-4 border-yellow-400">
                  <h4 className="text-yellow-400 font-bold text-xl mb-3">
                    ¿Por qué elegir nuestras mascletas en miniatura?
                  </h4>
                  <ul className="space-y-2 text-gray-200">
                    <li>• <strong>Espacios reducidos:</strong> Perfectas para calles estrechas, plazas pequeñas y jardines o terrenos privados</li>
                    <li>• <strong>Distancias de seguridad reducidas:</strong> Menor separación requerida tanto a edificios como al público</li>
                    <li>• <strong>Experiencia auténtica:</strong> Mantienen la esencia de la mascleta valenciana</li>
                    <li>• <strong>Versatilidad total:</strong> Adaptables a cualquier celebración</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* Ventajas Clave */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
            <div className="bg-gradient-to-b from-slate-600 to-slate-700 rounded-2xl p-8 text-center border border-yellow-400/20 hover:border-yellow-400/50 transition-all duration-300">
              <div className="bg-yellow-400 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-home-line text-black text-2xl"></i>
              </div>
              <h4 className="text-white font-bold text-xl mb-4">ESPACIOS ÍNTIMOS</h4>
              <p className="text-gray-300 text-sm leading-relaxed">
                Desde calles estrechas y plazas pequeñas hasta jardines o terrenos privados. 
                La mascleta llega donde antes era imposible.
              </p>
            </div>

            <div className="bg-gradient-to-b from-slate-600 to-slate-700 rounded-2xl p-8 text-center border border-yellow-400/20 hover:border-yellow-400/50 transition-all duration-300">
              <div className="bg-yellow-400 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-shield-check-line text-black text-2xl"></i>
              </div>
              <h4 className="text-white font-bold text-xl mb-4">MÁXIMA SEGURIDAD</h4>
              <p className="text-gray-300 text-sm leading-relaxed">
                Menor distancia de seguridad requerida tanto a edificios como al público. 
                Perfectas para zonas urbanas y espacios con normativas estrictas.
              </p>
            </div>

            <div className="bg-gradient-to-b from-slate-600 to-slate-700 rounded-2xl p-8 text-center border border-yellow-400/20 hover:border-yellow-400/50 transition-all duration-300">
              <div className="bg-yellow-400 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-heart-line text-black text-2xl"></i>
              </div>
              <h4 className="text-white font-bold text-xl mb-4">EXPERIENCIA AUTÉNTICA</h4>
              <p className="text-gray-300 text-sm leading-relaxed">
                Conservan toda la emoción y tradición de la mascleta valenciana 
                en un formato adaptado y accesible para todos.
              </p>
            </div>
          </div>

          {/* CTA Mascletas en Miniatura */}
          <div className="text-center">
            <div 
              className="relative bg-cover bg-center rounded-3xl p-16 border-4 border-yellow-400/30"
              style={{
                backgroundImage: `url('https://readdy.ai/api/search-image?query=intimate%20wedding%20celebration%20with%20miniature%20mascleta%20fireworks%20in%20small%20garden%20venue%2C%20guests%20watching%20small%20scale%20pyrotechnics%2C%20romantic%20evening%20setting%2C%20controlled%20safe%20environment%2C%20Valencia%20Spain%20tradition&width=800&height=400&seq=minimascleta2&orientation=landscape')`
              }}
            >
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/40 to-black/50 rounded-3xl"></div>
              <div className="relative z-10">
                <h3 className="text-4xl font-bold text-white mb-6 tracking-wider">
                  ¿QUIERES UNA MASCLETA EN TU EVENTO?
                </h3>
                <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto">
                  Descubre cómo podemos adaptar este espectáculo único a tu celebración
                </p>
                <button className="bg-gradient-to-r from-yellow-400 to-orange-500 text-black px-10 py-5 rounded-full font-bold text-xl tracking-wider hover:scale-105 transition-transform duration-300 flex items-center space-x-3 mx-auto cursor-pointer whitespace-nowrap shadow-2xl">
                  <i className="ri-sparkling-line text-2xl"></i>
                  <span>CONSULTAR DISPONIBILIDAD</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mascletas Tradicionales */}
      <section className="py-20 bg-gradient-to-b from-slate-600 to-slate-500 relative overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute top-15 right-15 w-4 h-4 bg-orange-500 rounded-full animate-pulse opacity-25"></div>
          <div className="absolute top-40 left-25 w-3 h-3 bg-yellow-500 rounded-full animate-bounce opacity-30" style={{animationDelay: '1.5s'}}></div>
          <div className="absolute bottom-25 right-1/4 w-3.5 h-3.5 bg-red-500 rounded-full animate-pulse opacity-20" style={{animationDelay: '2.5s'}}></div>
        </div>
        
        <div className="max-w-7xl mx-auto px-6 relative">
          <div className="text-center mb-16">
            <div className="bg-gradient-to-r from-orange-500 to-red-600 text-white px-6 py-3 rounded-full text-sm font-bold mb-6 inline-block tracking-wider shadow-lg">
              <i className="ri-fire-fill mr-2"></i>
              TRADICIÓN AUTÉNTICA VALENCIANA
            </div>
            <h2 className="text-6xl font-serif font-bold text-white tracking-wider mb-8">
              MASCLETAS
              <span className="block bg-gradient-to-r from-orange-500 via-red-500 to-yellow-500 bg-clip-text text-transparent">
                TRADICIONALES
              </span>
            </h2>
            <p className="text-2xl text-gray-300 max-w-4xl mx-auto leading-relaxed font-light">
              LA ESENCIA PURA DE LA MASCLETA VALENCIANA EN TODO SU ESPLENDOR
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-20">
            {/* Contenido Descriptivo */}
            <div>
              <h3 className="text-4xl font-bold text-white mb-8 tracking-wider">
                POTENCIA Y TRADICIÓN SIN LÍMITES
              </h3>
              
              <div className="space-y-6 text-gray-300 leading-relaxed">
                <p className="text-lg">
                  Las <strong className="text-orange-400">mascletas tradicionales</strong> representan la máxima expresión de la pirotécnica valenciana, 
                  utilizando <strong className="text-red-400">calibres de mayor potencia</strong> que crean ese sonido característico y esa intensidad 
                  que hace vibrar el suelo y emociona a multitudes.
                </p>
                
                <p className="text-lg">
                  Estos espectáculos requieren <strong className="text-orange-400">mayores distancias de seguridad tanto a edificios como al público</strong>, 
                  así como espacios más amplios que permitan cumplir con todas las medidas de seguridad establecidas por la normativa.
                </p>

                <p className="text-lg">
                  En Espectáculos Bronchú creamos tanto <strong className="text-yellow-400">diseños tradicionales</strong> que respetan 
                  la esencia centenaria de la mascleta valenciana, como <strong className="text-red-400">propuestas modernas</strong> que 
                  incorporan nuevos efectos y secuencias innovadoras.
                </p>

                <div className="bg-slate-500/50 rounded-xl p-6 border-l-4 border-orange-400">
                  <h4 className="text-orange-400 font-bold text-xl mb-3">
                    Características de nuestras mascletas tradicionales
                  </h4>
                  <ul className="space-y-2 text-gray-200">
                    <li>• <strong>Calibres de mayor potencia:</strong> Sonido intenso y característico de la tradición valenciana</li>
                    <li>• <strong>Mayores distancias de seguridad:</strong> Requieren espacios amplios y separación adecuada</li>
                    <li>• <strong>Diseño tradicional:</strong> Respetando la estructura clásica de la mascleta valenciana</li>
                    <li>• <strong>Propuestas modernas:</strong> Innovación en efectos y secuencias contemporáneas</li>
                    <li>• <strong>Espacios amplios:</strong> Ideales para plazas grandes, explanadas y festivales</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Imagen Principal */}
            <div className="relative">
              <div 
                className="h-96 bg-cover bg-center rounded-3xl shadow-2xl border-4 border-orange-400/50"
                style={{
                  backgroundImage: `url('https://readdy.ai/api/search-image?query=spectacular%20traditional%20mascleta%20fireworks%20display%20in%20large%20Valencia%20plaza%2C%20massive%20crowd%20watching%2C%20intense%20explosions%20with%20thick%20smoke%20clouds%2C%20traditional%20Spanish%20celebration%2C%20powerful%20pyrotechnics%2C%20dramatic%20daytime%20setting&width=600&height=400&seq=tradmascleta1&orientation=landscape')`
                }}
              >
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent rounded-3xl"></div>
                <div className="absolute bottom-6 left-6 right-6">
                  <div className="bg-black/70 backdrop-blur-sm rounded-lg p-4">
                    <p className="text-orange-400 font-bold text-lg">
                      MÁXIMA POTENCIA Y TRADICIÓN
                    </p>
                    <p className="text-white text-sm">
                      Para espacios amplios y grandes celebraciones
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Comparativa de Espacios */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
            <div className="bg-gradient-to-b from-slate-500 to-slate-600 rounded-2xl p-8 text-center border border-orange-400/20 hover:border-orange-400/50 transition-all duration-300">
              <div className="bg-orange-400 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-building-4-line text-white text-2xl"></i>
              </div>
              <h4 className="text-white font-bold text-xl mb-4">ESPACIOS AMPLIOS REQUERIDOS</h4>
              <p className="text-gray-300 text-sm leading-relaxed">
                Plazas grandes, explanadas, campos de fútbol y espacios abiertos. 
                Necesarios para cumplir las distancias de seguridad de calibres mayores.
              </p>
            </div>

            <div className="bg-gradient-to-b from-slate-500 to-slate-600 rounded-2xl p-8 text-center border border-red-400/20 hover:border-red-400/50 transition-all duration-300">
              <div className="bg-red-400 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-shield-star-line text-white text-2xl"></i>
              </div>
              <h4 className="text-white font-bold text-xl mb-4">MEDIDAS DE SEGURIDAD AMPLIADAS</h4>
              <p className="text-gray-300 text-sm leading-relaxed">
                Distancias de seguridad mayores tanto a edificios como al público. 
                Cumplimiento estricto de normativas para calibres de mayor potencia.
              </p>
            </div>
          </div>

          {/* Diseños Tradicionales vs Modernos */}
          <div className="mb-16">
            <h3 className="text-4xl font-bold text-white mb-12 text-center tracking-wider">
              TRADICIÓN E INNOVACIÓN
            </h3>
            
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
              {/* Diseño Tradicional */}
              <div className="relative group">
                <div 
                  className="h-80 bg-cover bg-center rounded-2xl border-4 border-yellow-400/50 overflow-hidden"
                  style={{
                    backgroundImage: `url('https://readdy.ai/api/search-image?query=classic%20traditional%20Valencia%20mascleta%20fireworks%20with%20historic%20architecture%20background%2C%20authentic%20Spanish%20celebration%2C%20traditional%20plaza%20setting%2C%20classical%20pyrotechnics%20display%2C%20heritage%20atmosphere&width=600&height=320&seq=tradmascleta2&orientation=landscape')`
                  }}
                >
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                  <div className="absolute top-6 left-6">
                    <span className="bg-yellow-400 text-black px-4 py-2 rounded-full text-sm font-bold flex items-center space-x-2">
                      <i className="ri-ancient-gate-line"></i>
                      <span>DISEÑO TRADICIONAL</span>
                    </span>
                  </div>
                  <div className="absolute bottom-6 left-6 right-6">
                    <h4 className="text-white font-bold text-2xl mb-3 tracking-wider">
                      ESENCIA VALENCIANA PURA
                    </h4>
                    <p className="text-gray-200 text-sm leading-relaxed">
                      Respetamos la estructura clásica, los tiempos tradicionales y la secuencia 
                      centenaria que hace de la mascleta un patrimonio cultural único.
                    </p>
                  </div>
                </div>
              </div>

              {/* Diseño Moderno */}
              <div className="relative group">
                <div 
                  className="h-80 bg-cover bg-center rounded-2xl border-4 border-cyan-400/50 overflow-hidden"
                  style={{
                    backgroundImage: `url('https://readdy.ai/api/search-image?query=modern%20innovative%20mascleta%20fireworks%20with%20contemporary%20effects%2C%20creative%20pyrotechnic%20sequences%2C%20modern%20urban%20setting%2C%20artistic%20fireworks%20display%2C%20innovative%20celebration%20design&width=600&height=320&seq=tradmascleta3&orientation=landscape')`
                  }}
                >
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                  <div className="absolute top-6 left-6">
                    <span className="bg-cyan-400 text-black px-4 py-2 rounded-full text-sm font-bold flex items-center space-x-2">
                      <i className="ri-rocket-2-line"></i>
                      <span>DISEÑO MODERNO</span>
                    </span>
                  </div>
                  <div className="absolute bottom-6 left-6 right-6">
                    <h4 className="text-white font-bold text-2xl mb-3 tracking-wider">
                      INNOVACIÓN Y CREATIVIDAD
                    </h4>
                    <p className="text-gray-200 text-sm leading-relaxed">
                      Incorporamos nuevos efectos, secuencias innovadoras y propuestas creativas 
                      que aportan frescura manteniendo el alma de la tradición.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* CTA Mascletas Tradicionales */}
          <div className="text-center">
            <div 
              className="relative bg-cover bg-center rounded-3xl p-16 border-4 border-orange-400/30"
              style={{
                backgroundImage: `url('https://readdy.ai/api/search-image?query=grand%20festival%20mascleta%20celebration%20in%20large%20Valencia%20plaza%2C%20massive%20crowd%20enjoying%20traditional%20fireworks%2C%20spectacular%20daytime%20pyrotechnics%2C%20community%20celebration%20atmosphere&width=800&height=400&seq=tradmascleta4&orientation=landscape')`
              }}
            >
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-black/40 rounded-3xl"></div>
              <div className="relative z-10">
                <h3 className="text-4xl font-bold text-white mb-6 tracking-wider">
                  ¿TIENES EL ESPACIO PARA UNA MASCLETA TRADICIONAL?
                </h3>
                <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto">
                  Descubre la potencia y emoción de la auténtica mascleta valenciana en tu gran evento
                </p>
                <button className="bg-gradient-to-r from-orange-500 to-red-600 text-white px-10 py-5 rounded-full font-bold text-xl tracking-wider hover:scale-105 transition-transform duration-300 flex items-center space-x-3 mx-auto cursor-pointer whitespace-nowrap shadow-2xl">
                  <i className="ri-fire-fill text-2xl"></i>
                  <span>CONSULTAR REQUISITOS</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Sección Especial de Bodas */}
      <section className="py-24 bg-gradient-to-b from-slate-500 to-rose-900 relative overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute top-20 left-20 w-3 h-3 bg-rose-300 rounded-full animate-pulse opacity-40"></div>
          <div className="absolute top-60 right-30 w-2 h-2 bg-pink-400 rounded-full animate-bounce opacity-30" style={{animationDelay: '1s'}}></div>
          <div className="absolute bottom-40 left-1/4 w-2.5 h-2.5 bg-rose-400 rounded-full animate-pulse opacity-25" style={{animationDelay: '2s'}}></div>
        </div>
        
        <div className="max-w-7xl mx-auto px-6 relative">
          <div className="text-center mb-20">
            <div className="bg-gradient-to-r from-rose-400 to-pink-500 text-white px-6 py-3 rounded-full text-sm font-bold mb-8 inline-block tracking-wider shadow-lg">
              <i className="ri-heart-fill mr-2"></i>
              MOMENTOS MÁGICOS E INOLVIDABLES
            </div>
            <h2 className="text-5xl md:text-6xl font-serif font-bold text-white tracking-wider mb-8 leading-tight">
              CREA UN RECUERDO
              <span className="block bg-gradient-to-r from-rose-400 via-pink-400 to-rose-300 bg-clip-text text-transparent">
                MÁGICO EN TU BODA
              </span>
            </h2>
            <p className="text-2xl text-rose-200 max-w-4xl mx-auto leading-relaxed font-light">
              YA SEA CON UNA MASCLETA O UN CASTILLO DE FUEGOS ARTIFICIALES HECHO A MEDIDA Y PODEMOS HACER LETREROS CON SUS NOMBRES
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-20">
            {/* Imagen Principal de Boda */}
            <div className="relative">
              <div 
                className="h-[500px] bg-cover bg-center rounded-3xl shadow-2xl border-4 border-rose-400/50"
                style={{
                  backgroundImage: `url('https://readdy.ai/api/search-image?query=romantic%20wedding%20fireworks%20display%20with%20bride%20and%20groom%20silhouettes%2C%20golden%20rose%20pink%20sparks%20cascading%2C%20elegant%20garden%20venue%20at%20twilight%2C%20magical%20romantic%20atmosphere%2C%20custom%20colored%20fireworks%2C%20luxury%20wedding%20celebration&width=600&height=500&seq=wedding-magic1&orientation=portrait')`
                }}
              >
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-rose-500/20 rounded-3xl"></div>
                <div className="absolute bottom-8 left-8 right-8">
                  <div className="bg-black/70 backdrop-blur-sm rounded-xl p-6 border border-rose-400/30">
                    <p className="text-rose-300 font-bold text-xl mb-2">
                      "EL MOMENTO PERFECTO PARA DECIR SÍ QUIERO"
                    </p>
                    <p className="text-white text-sm">
                      Personalizado con letreros de sus nombres y diseñado para su amor
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Contenido Descriptivo de Bodas */}
            <div>
              <h3 className="text-4xl font-bold text-white mb-8 tracking-wider">
                SUS NOMBRES BRILLANDO EN EL CIELO
              </h3>
              
              <div className="space-y-6 text-rose-100 leading-relaxed">
                <p className="text-lg">
                  Imagina el momento más importante de sus vidas iluminado por <strong className="text-rose-300">fuegos artificiales diseñados exclusivamente para ustedes</strong>. 
                  Ya sea una <strong className="text-pink-300">mascleta íntima en el jardín</strong> o un <strong className="text-rose-300">espectacular castillo aéreo</strong>, 
                  creamos el recuerdo perfecto.
                </p>
                
                <p className="text-lg">
                  Podemos crear <strong className="text-pink-300">letreros luminosos con sus nombres</strong> usando fuegos artificiales, 
                  desde el dorado más elegante hasta el blanco puro, 
                  pasando por cualquier combinación que refleje su personalidad como pareja.
                </p>

                <p className="text-lg">
                  Cada espectáculo se diseña <strong className="text-rose-300">a medida</strong>, teniendo en cuenta el espacio disponible, 
                  el número de invitados y, por supuesto, <strong className="text-pink-300">sus sueños</strong> para ese día tan especial.
                </p>

                <div className="bg-rose-800/40 rounded-xl p-6 border-l-4 border-rose-300 backdrop-blur-sm">
                  <h4 className="text-rose-300 font-bold text-xl mb-4">
                    <i className="ri-heart-2-fill mr-2"></i>
                    ¿Por qué elegir fuegos artificiales para su boda?
                  </h4>
                  <ul className="space-y-3 text-rose-100">
                    <li className="flex items-start">
                      <i className="ri-check-line text-rose-300 mr-3 mt-1"></i>
                      <div>
                        <strong>Momento único e irrepetible:</strong> Un recuerdo que durará toda la vida
                      </div>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-check-line text-rose-300 mr-3 mt-1"></i>
                      <div>
                        <strong>Letreros personalizados:</strong> Sus nombres brillando en el cielo
                      </div>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-check-line text-rose-300 mr-3 mt-1"></i>
                      <div>
                        <strong>Fotografías espectaculares:</strong> Imágenes mágicas que atesorarán para siempre
                      </div>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-check-line text-rose-300 mr-3 mt-1"></i>
                      <div>
                        <strong>Emoción compartida:</strong> Sus invitados vivirán un momento inolvidable
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* Opciones para Bodas */}
          <div className="mb-20">
            <h3 className="text-4xl font-bold text-white mb-12 text-center tracking-wider">
              OPCIONES PERFECTAS PARA SU BODA
            </h3>
            
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
              {/* Mascleta para Bodas */}
              <div className="relative group">
                <div 
                  className="h-96 bg-cover bg-center rounded-2xl border-4 border-rose-400/50 overflow-hidden"
                  style={{
                    backgroundImage: `url('https://readdy.ai/api/search-image?query=intimate%20wedding%20mascleta%20fireworks%20in%20elegant%20garden%20setting%2C%20bride%20and%20groom%20watching%20romantic%20small%20scale%20pyrotechnics%2C%20rose%20gold%20pink%20sparks%2C%20magical%20evening%20wedding%20celebration%2C%20luxury%20venue%20with%20fairy%20lights&width=600&height=384&seq=wedding-mascleta&orientation=landscape')`
                  }}
                >
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-rose-500/20"></div>
                  <div className="absolute top-6 left-6">
                    <span className="bg-rose-400 text-white px-4 py-2 rounded-full text-sm font-bold flex items-center space-x-2">
                      <i className="ri-heart-line"></i>
                      <span>MASCLETA NUPCIAL</span>
                    </span>
                  </div>
                  <div className="absolute bottom-8 left-8 right-8">
                    <h4 className="text-white font-bold text-2xl mb-3 tracking-wider">
                      MASCLETA PERSONALIZADA
                    </h4>
                    <p className="text-rose-200 text-sm leading-relaxed mb-4">
                      Perfecta para jardines íntimos y celebraciones con encanto. Diseñada con letreros de sus nombres 
                      y adaptada al espacio de su boda. Una explosión de amor y felicidad.
                    </p>
                    <ul className="space-y-1 text-rose-200 text-xs">
                      <li>• Ideal para espacios reducidos</li>
                      <li>• Letreros con nombres personalizados</li>
                      <li>• Segura para invitados cercanos</li>
                      <li>• Momento íntimo y especial</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* Castillo para Bodas */}
              <div className="relative group">
                <div 
                  className="h-96 bg-cover bg-center rounded-2xl border-4 border-pink-400/50 overflow-hidden"
                  style={{
                    backgroundImage: `url('https://readdy.ai/api/search-image?query=spectacular%20wedding%20fireworks%20castle%20display%20with%20rose%20gold%20colors%2C%20elegant%20aerial%20fireworks%20forming%20heart%20patterns%2C%20luxury%20wedding%20venue%20at%20night%2C%20romantic%20atmosphere%20with%20colorful%20bursts%2C%20bride%20and%20groom%20celebration%20under%20starry%20sky&width=600&height=384&seq=wedding-castle&orientation=landscape')`
                  }}
                >
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-pink-500/20"></div>
                  <div className="absolute top-6 left-6">
                    <span className="bg-pink-400 text-white px-4 py-2 rounded-full text-sm font-bold flex items-center space-x-2">
                      <i className="ri-sparkling-2-line"></i>
                      <span>CASTILLO NUPCIAL</span>
                    </span>
                  </div>
                  <div className="absolute bottom-8 left-8 right-8">
                    <h4 className="text-white font-bold text-2xl mb-3 tracking-wider">
                      CASTILLO AÉREO MÁGICO
                    </h4>
                    <p className="text-pink-200 text-sm leading-relaxed mb-4">
                      Un espectáculo aéreo que iluminará el cielo con sus nombres. Formas, patrones y efectos 
                      únicos que convertirán su boda en un cuento de hadas bajo las estrellas.
                    </p>
                    <ul className="space-y-1 text-pink-200 text-xs">
                      <li>• Espectáculo aéreo completo</li>
                      <li>• Diseños y formas personalizadas</li>
                      <li>• Letreros luminosos con nombres</li>
                      <li>• Gran impacto visual</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Paleta de Colores */}
          <div className="mb-20">
            <h3 className="text-4xl font-bold text-white mb-12 text-center tracking-wider">
              LETREROS LUMINOSOS PERSONALIZADOS
            </h3>
            
            <div className="bg-white/5 backdrop-blur-sm rounded-3xl p-8 border border-yellow-400/20">
              <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-6 mb-8">
                {/* Colores populares para bodas */}
                <div className="text-center group cursor-pointer">
                  <div className="w-16 h-16 bg-gradient-to-br from-yellow-200 to-yellow-400 rounded-full mx-auto mb-3 group-hover:scale-110 transition-transform duration-300 shadow-lg"></div>
                  <p className="text-rose-200 text-sm font-semibold">DORADO ELEGANTE</p>
                </div>
                <div className="text-center group cursor-pointer">
                  <div className="w-16 h-16 bg-gradient-to-br from-white to-gray-200 rounded-full mx-auto mb-3 group-hover:scale-110 transition-transform duration-300 shadow-lg"></div>
                  <p className="text-rose-200 text-sm font-semibold">BLANCO PURO</p>
                </div>
                <div className="text-center group cursor-pointer">
                  <div className="w-16 h-16 bg-gradient-to-br from-red-300 to-red-500 rounded-full mx-auto mb-3 group-hover:scale-110 transition-transform duration-300 shadow-lg"></div>
                  <p className="text-rose-200 text-sm font-semibold">ROJO PASIÓN</p>
                </div>
                <div className="text-center group cursor-pointer">
                  <div className="w-16 h-16 bg-gradient-to-br from-purple-300 to-purple-500 rounded-full mx-auto mb-3 group-hover:scale-110 transition-transform duration-300 shadow-lg"></div>
                  <p className="text-rose-200 text-sm font-semibold">LILA SOÑADOR</p>
                </div>
                <div className="text-center group cursor-pointer">
                  <div className="w-16 h-16 bg-gradient-to-br from-blue-200 to-blue-400 rounded-full mx-auto mb-3 group-hover:scale-110 transition-transform duration-300 shadow-lg"></div>
                  <p className="text-rose-200 text-sm font-semibold">AZUL CIELO</p>
                </div>
                <div className="text-center group cursor-pointer">
                  <div className="w-16 h-16 bg-gradient-to-br from-green-300 to-green-500 rounded-full mx-auto mb-3 group-hover:scale-110 transition-transform duration-300 shadow-lg"></div>
                  <p className="text-rose-200 text-sm font-semibold">VERDE NATURAL</p>
                </div>
              </div>
              
              <div className="text-center">
                <p className="text-rose-200 text-lg mb-4">
                  <i className="ri-edit-line text-rose-300 mr-2"></i>
                  <strong>Sus nombres brillando en el cielo</strong> con cualquier combinación de colores que elijan
                </p>
                <p className="text-rose-300 text-sm">
                  Podemos crear letreros luminosos con sus nombres, fechas especiales o palabras significativas.
                </p>
              </div>
            </div>
          </div>

          {/* Proceso de Personalización */}
          <div className="mb-20">
            <h3 className="text-4xl font-bold text-white mb-12 text-center tracking-wider">
              CÓMO CREAMOS SU MOMENTO PERFECTO
            </h3>
            
            <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
              <div className="text-center">
                <div className="bg-rose-400 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg">
                  <i className="ri-heart-3-line text-white text-2xl"></i>
                </div>
                <div className="bg-rose-900/30 rounded-lg p-6 border border-rose-400/20">
                  <h4 className="text-white font-bold text-lg mb-3">1. SUS SUEÑOS</h4>
                  <p className="text-rose-200 text-sm">
                    Nos cuentan sus ideas, nombres y cómo imaginan ese momento especial.
                  </p>
                </div>
              </div>
              
              <div className="text-center">
                <div className="bg-pink-400 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg">
                  <i className="ri-ruler-2-line text-white text-2xl"></i>
                </div>
                <div className="bg-rose-900/30 rounded-lg p-6 border border-rose-400/20">
                  <h4 className="text-white font-bold text-lg mb-3">2. DISEÑO A MEDIDA</h4>
                  <p className="text-rose-200 text-sm">
                    Estudiamos su espacio y diseñamos el espectáculo perfecto adaptado a su boda.
                  </p>
                </div>
              </div>
              
              <div className="text-center">
                <div className="bg-rose-300 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg">
                  <i className="ri-edit-line text-white text-2xl"></i>
                </div>
                <div className="bg-rose-900/30 rounded-lg p-6 border border-rose-400/20">
                  <h4 className="text-white font-bold text-lg mb-3">3. LETREROS ÚNICOS</h4>
                  <p className="text-rose-200 text-sm">
                    Diseñamos los letreros con sus nombres exactos para crear su mensaje personalizado.
                  </p>
                </div>
              </div>
              
              <div className="text-center">
                <div className="bg-red-400 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg">
                  <i className="ri-sparkling-fill text-white text-2xl"></i>
                </div>
                <div className="bg-rose-900/30 rounded-lg p-6 border border-rose-400/20">
                  <h4 className="text-white font-bold text-lg mb-3">4. MAGIA REAL</h4>
                  <p className="text-rose-200 text-sm">
                    El día de su boda, creamos ese momento mágico que recordarán para siempre.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* CTA Final para Bodas */}
          <div className="text-center">
            <div 
              className="relative bg-cover bg-center rounded-3xl p-16 border-4 border-rose-400/30"
              style={{
                backgroundImage: `url('https://readdy.ai/api/search-image?query=romantic%20wedding%20couple%20silhouette%20against%20magnificent%20fireworks%20display%2C%20heart%20shaped%20sparkles%2C%20rose%20gold%20colors%2C%20magical%20evening%20celebration%2C%20luxury%20wedding%20venue%2C%20dream%20wedding%20moment&width=800&height=400&seq=wedding-cta&orientation=landscape')`
              }}
            >
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/40 to-black/50 rounded-3xl"></div>
              <div className="relative z-10">
                <h3 className="text-4xl md:text-5xl font-bold text-white mb-6 tracking-wider leading-tight">
                  ¿LISTOS PARA CREAR<br />
                  <span className="bg-gradient-to-r from-rose-300 via-pink-300 to-rose-400 bg-clip-text text-transparent">
                    SU MOMENTO MÁGICO?
                  </span>
                </h3>
                <p className="text-xl text-rose-200 mb-8 max-w-3xl mx-auto leading-relaxed">
                  Cuéntennos sus sueños y crearemos el espectáculo perfecto con sus nombres brillando en el cielo
                </p>
                <button className="bg-gradient-to-r from-rose-400 to-pink-500 text-white px-10 py-5 rounded-full font-bold text-xl tracking-wider hover:scale-105 transition-transform duration-300 flex items-center space-x-3 mx-auto cursor-pointer whitespace-nowrap shadow-2xl">
                  <i className="ri-heart-2-fill text-2xl"></i>
                  <span>CREAR NUESTRO MOMENTO</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Sección de Adaptación y Asesoramiento */}
      <section className="py-20 bg-gradient-to-b from-rose-900 to-slate-700 relative overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute top-16 right-16 w-4 h-4 bg-yellow-400 rounded-full animate-pulse opacity-25"></div>
          <div className="absolute top-48 left-20 w-3 h-3 bg-orange-500 rounded-full animate-bounce opacity-30" style={{animationDelay: '1.2s'}}></div>
          <div className="absolute bottom-32 right-1/3 w-3.5 h-3.5 bg-red-500 rounded-full animate-pulse opacity-20" style={{animationDelay: '2.3s'}}></div>
        </div>
        
        <div className="max-w-7xl mx-auto px-6 relative">
          <div className="text-center mb-16">
            <div className="bg-gradient-to-r from-yellow-400 to-orange-500 text-black px-6 py-3 rounded-full text-sm font-bold mb-6 inline-block tracking-wider shadow-lg">
              <i className="ri-lightbulb-line mr-2"></i>
              ASESORAMIENTO PERSONALIZADO
            </div>
            <h2 className="text-5xl md:text-6xl font-serif font-bold text-white tracking-wider mb-8 leading-tight">
              NOS ADAPTAMOS AL
              <span className="block bg-gradient-to-r from-yellow-400 via-orange-400 to-red-500 bg-clip-text text-transparent">
                ESPECTÁCULO QUE QUIERAS
              </span>
            </h2>
            <p className="text-2xl text-gray-300 max-w-4xl mx-auto leading-relaxed font-light">
              APORTAMOS ASESORAMIENTO E INTENTAMOS PLASMAR TUS IDEAS EN NUESTROS DISEÑOS, ADAPTÁNDONOS AL PRESUPUESTO EN LA MEDIDA DE LO POSIBLE
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-20">
            {/* Contenido Principal */}
            <div>
              <h3 className="text-4xl font-bold text-white mb-8 tracking-wider">
                TU VISIÓN, NUESTRO COMPROMISO
              </h3>
              
              <div className="space-y-6 text-gray-300 leading-relaxed">
                <p className="text-lg">
                  En Espectáculos Bronchú entendemos que <strong className="text-yellow-400">cada cliente tiene una visión única</strong> 
                  para su evento. Por eso, nuestro enfoque principal es <strong className="text-orange-400">escuchar tus ideas</strong> 
                  y trabajar contigo para hacerlas realidad.
                </p>
                
                <p className="text-lg">
                  No importa si tienes un concepto completamente definido o solo una idea inicial, 
                  <strong className="text-yellow-400"> nuestro equipo de especialistas te proporcionará asesoramiento profesional</strong> 
                  para ayudarte a desarrollar el espectáculo perfecto para tu celebración.
                </p>

                <p className="text-lg">
                  Comprendemos que cada presupuesto es diferente, por eso 
                  <strong className="text-orange-400"> nos esforzamos por adaptar nuestros diseños a tus posibilidades económicas</strong>, 
                  siempre manteniendo la calidad y seguridad que nos caracteriza.
                </p>

                <div className="bg-slate-600/50 rounded-xl p-6 border-l-4 border-yellow-400 backdrop-blur-sm">
                  <h4 className="text-yellow-400 font-bold text-xl mb-4">
                    <i className="ri-user-heart-line mr-2"></i>
                    Nuestro proceso de asesoramiento
                  </h4>
                  <ul className="space-y-3 text-gray-200">
                    <li className="flex items-start">
                      <i className="ri-ear-line text-yellow-400 mr-3 mt-1"></i>
                      <div>
                        <strong>Escuchamos tus ideas:</strong> Conocemos tu visión, expectativas y necesidades específicas
                      </div>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-lightbulb-flash-line text-yellow-400 mr-3 mt-1"></i>
                      <div>
                        <strong>Aportamos experiencia:</strong> Te asesoramos sobre las mejores opciones técnicas y creativas
                      </div>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-pencil-ruler-2-line text-yellow-400 mr-3 mt-1"></i>
                      <div>
                        <strong>Plasmamos el diseño:</strong> Convertimos tus ideas en un espectáculo técnicamente viable
                      </div>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-money-euro-circle-line text-yellow-400 mr-3 mt-1"></i>
                      <div>
                        <strong>Adaptamos al presupuesto:</strong> Ajustamos la propuesta a tus posibilidades económicas
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Imagen Ilustrativa */}
            <div className="relative">
              <div 
                className="h-[500px] bg-cover bg-center rounded-3xl shadow-2xl border-4 border-yellow-400/50"
                style={{
                  backgroundImage: `url('https://static.readdy.ai/image/f83f5cd629da4d80734129e80e4e4145/21d5ff3b67bca9d38b7b09b30725c293.webp')`
                }}
              >
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-yellow-500/10 rounded-3xl"></div>
              </div>
            </div>
          </div>

          {/* Servicios de Adaptación */}
          <div className="mb-20">
            <h3 className="text-4xl font-bold text-white mb-12 text-center tracking-wider">
              CÓMO NOS ADAPTAMOS A TI
            </h3>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {/* Adaptación de Espacio */}
              <div className="bg-slate-600/50 rounded-2xl p-8 text-center border border-yellow-400/20 hover:border-yellow-400/50 transition-all duration-300">
                <div className="bg-yellow-400 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-ruler-2-line text-black text-2xl"></i>
                </div>
                <h4 className="text-white font-bold text-xl mb-4 tracking-wider">ADAPTACIÓN DE ESPACIO</h4>
                <p className="text-gray-300 text-sm leading-relaxed">
                  Estudiamos las dimensiones y características de tu ubicación para diseñar 
                  el espectáculo que mejor se adapte al espacio disponible.
                </p>
              </div>

              {/* Adaptación de Presupuesto */}
              <div className="bg-slate-600/50 rounded-2xl p-8 text-center border border-orange-400/20 hover:border-orange-400/50 transition-all duration-300">
                <div className="bg-orange-400 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-wallet-line text-white text-2xl"></i>
                </div>
                <h4 className="text-white font-bold text-xl mb-4 tracking-wider">ADAPTACIÓN DE PRESUPUESTO</h4>
                <p className="text-gray-300 text-sm leading-relaxed">
                  Ofrecemos diferentes opciones y escalas de espectáculos para ajustarnos 
                  a tu presupuesto sin comprometer la calidad y seguridad.
                </p>
              </div>

              {/* Adaptación Creativa */}
              <div className="bg-slate-600/50 rounded-2xl p-8 text-center border border-red-400/20 hover:border-red-400/50 transition-all duration-300">
                <div className="bg-red-400 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-palette-line text-white text-2xl"></i>
                </div>
                <h4 className="text-white font-bold text-xl mb-4 tracking-wider">ADAPTACIÓN CREATIVA</h4>
                <p className="text-gray-300 text-sm leading-relaxed">
                  Plasmamos tus ideas únicas en diseños personalizados, desde colores 
                  específicos hasta efectos especiales que reflejen tu visión.
                </p>
              </div>
            </div>
          </div>

          {/* CTA Asesoramiento */}
          <div className="text-center">
            <div 
              className="relative bg-cover bg-center rounded-3xl p-16 border-4 border-yellow-400/30"
              style={{
                backgroundImage: `url('https://readdy.ai/api/search-image?query=collaborative%20consultation%20meeting%2C%20client%20and%20expert%20discussing%20custom%20fireworks%20plans%2C%20professional%20advisory%20service%2C%20personalized%20planning%20session%2C%20technical%20expertise%20and%20creativity%20combined&width=800&height=400&seq=consultation-cta&orientation=landscape')`
              }}
            >
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/50 to-black/40 rounded-3xl"></div>
              <div className="relative z-10">
                <h3 className="text-4xl md:text-5xl font-bold text-white mb-6 tracking-wider leading-tight">
                  ¿TIENES UNA IDEA?<br />
                  <span className="bg-gradient-to-r from-yellow-400 via-orange-400 to-red-500 bg-clip-text text-transparent">
                    ¡HAGÁMOSLA REALIDAD!
                  </span>
                </h3>
                <p className="text-xl text-gray-300 mb-8 max-w-3xl mx-auto leading-relaxed">
                  Cuéntanos tu visión y trabajaremos juntos para crear el espectáculo perfecto adaptado a tus necesidades y presupuesto
                </p>
                <div className="flex flex-col md:flex-row gap-6 justify-center">
                  <button className="bg-gradient-to-r from-yellow-400 to-orange-500 text-black px-10 py-5 rounded-full font-bold text-xl tracking-wider hover:scale-105 transition-transform duration-300 flex items-center space-x-3 mx-auto md:mx-0 cursor-pointer whitespace-nowrap shadow-2xl">
                    <i className="ri-customer-service-2-line text-2xl"></i>
                    <span>SOLICITAR ASESORAMIENTO</span>
                  </button>
                  <a href="/contacto" className="border-3 border-yellow-400 text-yellow-400 px-10 py-5 rounded-full font-bold text-xl tracking-wider hover:bg-yellow-400 hover:text-black transition-all duration-300 cursor-pointer whitespace-nowrap shadow-2xl mx-auto md:mx-0 text-center">
                    <i className="ri-phone-line text-2xl mr-3"></i>
                    CONTACTAR AHORA
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Servicios de Pirotécnia */}
      <section className="py-20 bg-gradient-to-b from-slate-700 to-slate-600">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <p className="text-yellow-400 text-sm font-semibold tracking-widest mb-4">
              NUESTROS SERVICIOS
            </p>
            <h2 className="text-5xl font-serif font-bold text-white tracking-wider">
              ESPECIALIDADES EN FUEGOS ARTIFICIALES
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Mascletas en Miniatura - Destacada */}
            <div className="relative group cursor-pointer hover:scale-105 transition-transform duration-300">
              <div 
                className="h-80 bg-gradient-to-br from-orange-500 to-red-600 rounded-2xl overflow-hidden relative border-4 border-yellow-400"
                style={{
                  backgroundImage: `url('https://readdy.ai/api/search-image?query=miniature%20mascleta%20fireworks%20display%20in%20small%20scale%2C%20detailed%20close-up%20view%2C%20intricate%20small%20explosions%2C%20golden%20orange%20red%20sparks%2C%20professional%20miniature%20pyrotechnics%2C%20indoor%20demonstration%2C%20controlled%20environment&width=400&height=320&seq=21&orientation=portrait')`
                }}
              >
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                <div className="absolute top-4 left-4">
                  <span className="bg-black text-yellow-400 px-3 py-1 rounded-full text-xs font-bold flex items-center space-x-1">
                    <i className="ri-star-fill"></i>
                    <span>ESPECIALIDAD</span>
                  </span>
                </div>
                <div className="absolute bottom-6 left-6">
                  <h3 className="text-white text-2xl font-bold tracking-wider mb-2">
                    MASCLETA EN<br />MINIATURA
                  </h3>
                  <p className="text-gray-200 text-sm">
                    INNOVACIÓN ÚNICA EN PIROTÉCNICA
                  </p>
                </div>
              </div>
            </div>

            {/* Mascletas Tradicionales */}
            <div className="relative group cursor-pointer hover:scale-105 transition-transform duration-300">
              <div 
                className="h-80 bg-cover bg-center rounded-2xl overflow-hidden relative"
                style={{
                  backgroundImage: `url('https://readdy.ai/api/search-image?query=traditional%20mascleta%20fireworks%20display%20Valencia%20style%2C%20intense%20explosions%2C%20massive%20smoke%20clouds%2C%20traditional%20Spanish%20pyrotechnics%2C%20plaza%20setting%2C%20dramatic%20daytime%20fireworks&width=400&height=320&seq=22&orientation=portrait')`
                }}
              >
                <div className="absolute inset-0 bg-black/40"></div>
                <div className="absolute top-4 left-4">
                  <span className="bg-black/60 text-orange-400 px-3 py-1 rounded-full text-xs font-bold flex items-center space-x-1 backdrop-blur-sm">
                    <i className="ri-fire-line"></i>
                    <span>TRADICIONAL</span>
                  </span>
                </div>
                <div className="absolute bottom-6 left-6">
                  <h3 className="text-white text-2xl font-bold tracking-wider font-serif mb-2">
                    MASCLETAS<br />TRADICIONALES
                  </h3>
                  <p className="text-gray-200 text-sm">
                    AUTÉNTICA TRADICIÓN VALENCIANA
                  </p>
                </div>
              </div>
            </div>

            {/* Castillos - Con funcionalidad de modal */}
            <div 
              className="relative group cursor-pointer hover:scale-105 transition-transform duration-300"
              onClick={() => setShowCastillosModal(true)}
            >
              <div 
                className="h-80 bg-cover bg-center rounded-2xl overflow-hidden relative"
                style={{
                  backgroundImage: `url('https://readdy.ai/api/search-image?query=spectacular%20aerial%20fireworks%20display%20with%20vibrant%20colorful%20explosions%20in%20night%20sky%2C%20professional%20pyrotechnics%20show%2C%20multiple%20bright%20colored%20bursts%2C%20golden%20red%20blue%20purple%20sparks%20cascading%2C%20celebration%20fireworks%20without%20structures%2C%20pure%20aerial%20display&width=400&height=320&seq=53&orientation=portrait')`
                }}
              >
                <div className="absolute inset-0 bg-black/40"></div>
                <div className="absolute top-4 left-4">
                  <span className="bg-black/60 text-yellow-400 px-3 py-1 rounded-full text-xs font-bold flex items-center space-x-1 backdrop-blur-sm">
                    <i className="ri-building-line"></i>
                    <span>CASTILLOS</span>
                  </span>
                </div>
                <div className="absolute bottom-6 left-6">
                  <h3 className="text-white text-2xl font-bold tracking-wider font-serif mb-2">
                    CASTILLOS<br />PIROTÉCNICOS
                  </h3>
                  <p className="text-pink-200 text-sm">
                    ESTRUCTURAS ESPECTACULARES
                  </p>
                </div>
                <div className="absolute inset-0 bg-yellow-400/0 group-hover:bg-yellow-400/20 transition-all duration-300 rounded-2xl"></div>
                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <i className="ri-eye-line text-white text-3xl bg-black/50 rounded-full p-3"></i>
                </div>
              </div>
            </div>

            {/* Bodas y Celebraciones */}
            <div className="relative group cursor-pointer hover:scale-105 transition-transform duration-300">
              <div 
                className="h-80 bg-cover bg-center rounded-2xl overflow-hidden relative"
                style={{
                  backgroundImage: `url('https://readdy.ai/api/search-image?query=romantic%20wedding%20fireworks%20celebration%2C%20bride%20and%20groom%20watching%20fireworks%2C%20elegant%20garden%20venue%2C%20golden%20white%20sparks%2C%20magical%20romantic%20atmosphere%2C%20luxury%20wedding%20celebration&width=400&height=320&seq=24&orientation=portrait')`
                }}
              >
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-pink-500/20"></div>
                <div className="absolute top-4 right-4">
                  <span className="bg-pink-400 text-white w-8 h-8 rounded-full flex items-center justify-center text-lg font-bold">
                    <i className="ri-heart-line"></i>
                  </span>
                </div>
                <div className="absolute bottom-6 left-6">
                  <h3 className="text-white text-2xl font-bold tracking-wider font-serif mb-2">
                    BODAS Y<br />CELEBRACIONES
                  </h3>
                  <p className="text-pink-200 text-sm">
                    MOMENTOS MÁGICOS E INOLVIDABLES
                  </p>
                </div>
              </div>
            </div>

            {/* Eventos Corporativos */}
            <div className="relative group cursor-pointer hover:scale-105 transition-transform duration-300">
              <div 
                className="h-80 bg-cover bg-center rounded-2xl overflow-hidden relative"
                style={{
                  backgroundImage: `url('https://readdy.ai/api/search-image?query=corporate%20event%20fireworks%20display%2C%20business%20celebration%2C%20professional%20venue%2C%20elegant%20fireworks%20show%2C%20corporate%20party%20atmosphere%2C%20sophisticated%20lighting&width=400&height=320&seq=25&orientation=portrait')`
                }}
              >
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-blue-600/20"></div>
                <div className="absolute top-4 right-4">
                  <span className="bg-blue-400 text-black w-8 h-8 rounded-full flex items-center justify-center text-lg font-bold">
                    <i className="ri-building-2-line"></i>
                  </span>
                </div>
                <div className="absolute bottom-6 left-6">
                  <h3 className="text-white text-2xl font-bold tracking-wider mb-2">
                    EVENTOS<br />CORPORATIVOS
                  </h3>
                  <p className="text-gray-200 text-sm">
                    PROFESIONALIDAD Y ELEGANCIA
                  </p>
                </div>
              </div>
            </div>

            {/* Espectáculos Personalizados */}
            <div className="relative group cursor-pointer hover:scale-105 transition-transform duration-300">
              <div 
                className="h-80 bg-cover bg-center rounded-2xl overflow-hidden relative border-2 border-dashed border-yellow-400"
                style={{
                  backgroundImage: `url('https://readdy.ai/api/search-image?query=custom%20personalized%20fireworks%20show%2C%20unique%20pyrotechnic%20display%2C%20artistic%20fireworks%20arrangement%2C%20creative%20explosion%20patterns%2C%20bespoke%20celebration%2C%20innovative%20pyrotechnics&width=400&height=320&seq=26&orientation=portrait')`
                }}
              >
                <div className="absolute inset-0 bg-black/50"></div>
                <div className="absolute top-4 right-4">
                  <span className="bg-yellow-400 text-black w-8 h-8 rounded-full flex items-center justify-center text-lg font-bold">
                    <i className="ri-add-line"></i>
                  </span>
                </div>
                <div className="absolute bottom-6 left-6">
                  <h3 className="text-white text-2xl font-bold tracking-wider mb-2">
                    ESPECTÁCULOS<br />PERSONALIZADOS
                  </h3>
                  <p className="text-gray-200 text-sm">
                    DISEÑAMOS TU SUEÑO
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Proceso y Seguridad */}
      <section className="py-20 bg-gradient-to-b from-slate-600 to-gray-700">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-4xl font-serif font-bold text-white mb-8 tracking-wider">
                PROFESIONALIDAD Y SEGURIDAD
              </h2>
              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="bg-yellow-400 w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-shield-check-line text-black text-xl"></i>
                  </div>
                  <div>
                    <h3 className="text-white font-bold text-xl mb-3">MÁXIMA SEGURIDAD</h3>
                    <p className="text-gray-300">
                      Todos nuestros espectáculos cumplen con la normativa vigente y contamos con seguros de responsabilidad civil.
                    </p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-4">
                  <div className="bg-yellow-400 w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-award-line text-black text-xl"></i>
                  </div>
                  <div>
                    <h3 className="text-white font-bold text-xl mb-3">17 AÑOS DE EXPERIENCIA</h3>
                    <p className="text-gray-300">
                      Nuestra dilatada experiencia nos avala como especialistas en fuegos artificiales profesionales.
                    </p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-4">
                  <div className="bg-yellow-400 w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-tools-line text-black text-xl"></i>
                  </div>
                  <div>
                    <h3 className="text-white font-bold text-xl mb-3">TÉCNICOS ESPECIALIZADOS</h3>
                    <p className="text-gray-300">
                      Contamos con un equipo de técnicos especializados con la máxima cualificación y experiencia.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <div 
                className="h-96 bg-cover bg-center rounded-3xl shadow-2xl"
                style={{
                  backgroundImage: `url('https://readdy.ai/api/search-image?query=professional%20pyrotechnic%20team%20setting%20up%20fireworks%20display%2C%20safety%20equipment%20and%20professional%20gear%2C%20technical%20experts%20working%20in%20coordinated%20team%2C%20fireworks%20safety%20protocols%2C%20professional%20pyrotechnics%20setup&width=600&height=400&seq=safety1&orientation=landscape')`
                }}
              >
                <div className="h-full bg-gradient-to-t from-black/50 to-transparent rounded-3xl"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gradient-to-t from-slate-800 to-gray-700 py-16">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center">
            <h3 className="text-white text-2xl font-serif font-bold mb-4">
              ¿LISTO PARA TU ESPECTÁCULO DE FUEGOS ARTIFICIALES?
            </h3>
            <p className="text-gray-300 mb-8">
              Contacta con nosotros y crearemos un espectáculo único para tu evento
            </p>
            <div className="flex flex-col md:flex-row items-center justify-center space-y-4 md:space-y-0 md:space-x-6">
              <a href="/contacto" className="bg-yellow-400 text-black px-8 py-4 rounded-lg font-bold text-lg tracking-wider hover:scale-105 transition-transform duration-300 cursor-pointer whitespace-nowrap">
                SOLICITAR PRESUPUESTO
              </a>
            </div>
          </div>
        </div>
      </footer>

      {/* Modal de Castillos Pirotécnicos */}
      {showCastillosModal && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="bg-gradient-to-b from-slate-800 to-slate-900 rounded-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto border-2 border-yellow-400/30">
            {/* Header del Modal */}
            <div className="relative p-6 border-b border-yellow-400/20">
              <button
                onClick={() => setShowCastillosModal(false)}
                className="absolute top-4 right-4 text-gray-400 hover:text-white w-10 h-10 flex items-center justify-center rounded-full hover:bg-white/10 transition-all duration-200 cursor-pointer"
              >
                <i className="ri-close-line text-xl"></i>
              </button>
              <div className="flex items-center space-x-4">
                <div className="bg-yellow-400 w-16 h-16 rounded-xl flex items-center justify-center">
                  <i className="ri-building-line text-black text-2xl"></i>
                </div>
                <div>
                  <h2 className="text-3xl font-bold text-white tracking-wider">
                    CASTILLOS PIROTÉCNICOS
                  </h2>
                  <p className="text-yellow-400 font-serif">
                    Espectáculos aéreos de gran envergadura
                  </p>
                </div>
              </div>
            </div>

            {/* Contenido del Modal */}
            <div className="p-6">
              {/* Imagen principal */}
              <div 
                className="h-64 bg-cover bg-center rounded-xl mb-6"
                style={{
                  backgroundImage: `url('https://readdy.ai/api/search-image?query=magnificent%20aerial%20fireworks%20castle%20display%2C%20massive%20colorful%20explosions%20in%20formation%2C%20professional%20pyrotechnics%20show%20with%20multiple%20synchronized%20bursts%2C%20spectacular%20night%20sky%20celebration%2C%20golden%20red%20blue%20sparks%2C%20grand%20finale%20fireworks%20without%20ground%20structures&width=800&height=400&seq=54&orientation=landscape')`
                }}
              >
                <div className="h-full bg-gradient-to-t from-black/50 to-transparent rounded-xl"></div>
              </div>

              {/* Descripción */}
              <div className="mb-8">
                <h3 className="text-2xl font-bold text-white mb-4">¿Qué son los Castillos Pirotécnicos?</h3>
                <p className="text-gray-300 text-lg leading-relaxed mb-4">
                  Los castillos pirotécnicos son espectáculos de fuegos artificiales aéreos que crean formaciones espectaculares en el cielo. 
                  Estos montajes coordinados producen explosiones sincronizadas que forman patrones visuales impresionantes, 
                  combinando colores, formas y efectos sonoros en una experiencia única.
                </p>
                <p className="text-gray-300 text-lg leading-relaxed">
                  Con más de 25 años de experiencia, en Espectáculos Bronchú diseñamos castillos personalizados 
                  adaptados a cada evento, desde celebraciones íntimas hasta grandes festivales.
                </p>
              </div>

              {/* Características */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                <div className="bg-slate-700/50 rounded-xl p-6">
                  <h4 className="text-yellow-400 font-bold text-lg mb-3 flex items-center">
                    <i className="ri-time-line mr-2"></i>
                    DURACIÓN
                  </h4>
                  <p className="text-gray-300">
                    • Espectáculos de 3 a 15 minutos<br/>
                    • Finales apoteósicos de 30-60 segundos<br/>
                    • Adaptable según el evento
                  </p>
                </div>

                <div className="bg-slate-700/50 rounded-xl p-6">
                  <h4 className="text-yellow-400 font-bold text-lg mb-3 flex items-center">
                    <i className="ri-palette-line mr-2"></i>
                    EFECTOS VISUALES
                  </h4>
                  <p className="text-gray-300">
                    • Colores personalizables<br/>
                    • Formas y patrones únicos<br/>
                    • Efectos de luz sincronizados
                  </p>
                </div>

                <div className="bg-slate-700/50 rounded-xl p-6">
                  <h4 className="text-yellow-400 font-bold text-lg mb-3 flex items-center">
                    <i className="ri-map-pin-line mr-2"></i>
                    ESPACIOS
                  </h4>
                  <p className="text-gray-300">
                    • Plazas y espacios abiertos<br/>
                    • Playas y explanadas<br/>
                    • Jardines de celebración
                  </p>
                </div>

                <div className="bg-slate-700/50 rounded-xl p-6">
                  <h4 className="text-yellow-400 font-bold text-lg mb-3 flex items-center">
                    <i className="ri-shield-check-line mr-2"></i>
                    SEGURIDAD
                  </h4>
                  <p className="text-gray-300">
                    • Permisos y licencias<br/>
                    • Seguros de responsabilidad<br/>
                    • Personal especializado
                  </p>
                </div>
              </div>

              {/* Tipos de Eventos */}
              <div className="mb-8">
                <h3 className="text-2xl font-bold text-white mb-6">Perfectos para estos eventos</h3>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                  <div className="text-center p-4 bg-gradient-to-b from-yellow-400/10 to-transparent rounded-lg border border-yellow-400/20">
                    <i className="ri-heart-line text-yellow-400 text-3xl mb-2"></i>
                    <p className="text-white font-semibold text-sm">BODAS</p>
                  </div>
                  <div className="text-center p-4 bg-gradient-to-b from-yellow-400/10 to-transparent rounded-lg border border-yellow-400/20">
                    <i className="ri-calendar-event-line text-yellow-400 text-3xl mb-2"></i>
                    <p className="text-white font-semibold text-sm">FESTIVALES</p>
                  </div>
                  <div className="text-center p-4 bg-gradient-to-b from-yellow-400/10 to-transparent rounded-lg border border-yellow-400/20">
                    <i className="ri-building-2-line text-yellow-400 text-3xl mb-2"></i>
                    <p className="text-white font-semibold text-sm">CORPORATIVOS</p>
                  </div>
                  <div className="text-center p-4 bg-gradient-to-b from-yellow-400/10 to-transparent rounded-lg border border-yellow-400/20">
                    <i className="ri-cake-line text-yellow-400 text-3xl mb-2"></i>
                    <p className="text-white font-semibold text-sm">CELEBRACIONES</p>
                  </div>
                </div>
              </div>

              {/* Botones de acción */}
              <div className="flex flex-col md:flex-row gap-4">
                <button 
                  onClick={() => setShowCastillosModal(false)}
                  className="flex-1 bg-gradient-to-r from-yellow-400 to-orange-500 text-black px-6 py-4 rounded-lg font-bold text-lg tracking-wider hover:scale-105 transition-transform duration-300 flex items-center justify-center space-x-2 cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-phone-line"></i>
                  <span>SOLICITAR PRESUPUESTO</span>
                </button>
                <button 
                  onClick={() => {
                    setShowCastillosModal(false);
                    window.location.href = '/videos';
                  }}
                  className="flex-1 border-2 border-yellow-400 text-yellow-400 px-6 py-4 rounded-lg font-bold text-lg tracking-wider hover:bg-yellow-400 hover:text-black transition-all duration-300 flex items-center justify-center space-x-2 cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-play-circle-line"></i>
                  <span>VER VIDEOS</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PirotecniaPage;
